<!-- Generated by AI start - Cursor - 2025-08-22 -->
<template>
  <div class="error-page">
    <div class="error-content">
      <div class="error-icon">
        <img src="@/assets/pc/fork_red.svg" alt="错误" />
      </div>
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  data() {
    return {
      errorMessage: ""
    };
  },
  mounted() {
    const msg = this.$route.query.msg;
    // 对URL编码的消息进行解码
    this.errorMessage = msg ? decodeURIComponent(msg) : "发生未知错误";
  }
};
</script>

<style scoped>
.error-page {
  width: 100%;
  height: 100vh;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  background-color: #f5f5f5;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
}

.error-content {
  text-align: center;
  padding: 40px 20px;
  margin-top: 100px;
}

.error-icon {
  margin-bottom: 30px;
}

.error-icon img {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.error-message {
  font-size: 16px;
  color: #666666;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}

/* 响应式适配 */
@media (max-width: 375px) {
  .error-icon {
    margin-bottom: 20px;
  }

  .error-icon img {
    width: 80px;
    height: 80px;
  }

  .error-message {
    font-size: 14px;
  }
}
</style>
<!-- Generated by AI end -->
